import { createGlobalStyle, css } from 'styled-components';

const MediaLibraryPopupStyle = createGlobalStyle`${css`
	:root {
		--mediaLibraryPopupImageSizes: var(--sp114x);
		--mediaLibraryPopupPadding: 0 var(--sp7x) var(--sp7x) var(--sp7x);
		--mediaLibraryPopupImageMarginRight: var(--sp8x);
		--mediaLibraryPopupContentWrapMarginTop: var(--sp13x);
		--mediaLibraryPopupNameMargin: var(--sp5x) 0;
		--mediaLibraryPopupInfoBlockMarginBottom: var(--sp3x);
		--mediaLibraryPopupInfoBlockMarginRight: var(--sp3x);
		--mediaLibraryPopupMaxWidth: calc(var(--sp200x) + var(--sp9x));

		--downloadLinkMinWidth: var(--sp34x);
		--downloadLinkPadding: var(--sp2x) var(--sp4x);
		--downloadLinkMarginTop: var(--sp3x);
		--downloadLinkIconSizes: var(--sp2x);
		--downloadLinkIconMarginLeft: var(--sp1-5x);

		--pdfPageControlsMarginTop: var(--sp8x);
		--pdfPageCounterMarginLeftRight: 0 var(--sp3x);
	}

	.media-library-popup-video {
		video {
			object-fit: contain !important;
		}
	}

	.pdf-cont {
		position: relative;
		width: 100%;
		padding-top: 100%;

		.react-pdf__Document {
			position: absolute;
			top: 0;
			left: 0;
			object-position: center;
			width: 100%;
			height: 100%;
			z-index: 1;
			border: 1px solid var(--primaryColor1);
			border-radius: var(--sp2x);
			display: flex;
			justify-content: center;
			align-items: center;
			overflow: hidden;
		}

		.pdf-view {
			display: flex;
			align-items: center;
			justify-content: center;
			height: 100%;
		}

		.pdf-view {
			max-width: 100%;
			max-height: 100%;

			canvas {
				display: flex;
				max-width: 100%;
				max-height: 100%;
				height: auto !important;
				width: auto !important;
			}
		}
	}

	.page-controls {
		display: flex;
		align-items: center;
		margin-top: var(--pdfPageControlsMarginTop);

		.page-counter {
			font-size: var(--pS);
			margin: var(--pdfPageCounterMarginLeftRight);
			display: grid;
			grid-template-columns: 1.2fr 1fr 1fr;
			gap: var(--sp0-5x);
			span {
				&:nth-child(1) {
					text-align: center;
				}
				&:nth-child(2) {
					text-align: center;
				}
				&:nth-child(3) {
					text-align: right;
				}
			}
		}

		.pdf-page-button {
			display: flex;
			align-items: center;
			padding: 0;
			background-color: transparent;
			border: none;
			outline: none;
			cursor: pointer;

			&.disable {
				opacity: 50%;
				pointer-events: none;
			}

			.pdf-arrow {
				font-size: var(--p);

				&.pdf-next {
					display: block;
					transform: rotate(180deg);
				}
			}
		}
	}

	.popup-content-container {
		max-width: var(--mediaLibraryPopupMaxWidth) !important;
	}

	.media-library-popup-styles {
		display: flex;
		padding: var(--mediaLibraryPopupPadding);

		.media-library-popup-image {
			width: 100%;
			max-width: var(--mediaLibraryPopupImageSizes);
			padding-top: var(--mediaLibraryPopupImageSizes);
			margin-right: var(--mediaLibraryPopupImageMarginRight);

			img {
				border-radius: var(--sp3x);
			}
		}

		.media-library-popup-pdf {
			width: 100%;
			max-width: var(--mediaLibraryPopupImageSizes);
			margin-right: var(--mediaLibraryPopupImageMarginRight);
		}

		.media-library-popup-content-wrap {
			display: flex;
			flex-direction: column;
			margin-top: var(--mediaLibraryPopupContentWrapMarginTop);

			.media-library-popup-name {
				margin: var(--mediaLibraryPopupNameMargin);
			}

			.media-library-popup-info-block {
				display: flex;
				margin-bottom: var(--mediaLibraryPopupInfoBlockMarginBottom);

				.media-library-info-block-left {
					margin-right: var(--mediaLibraryPopupInfoBlockMarginRight);
				}
			}
		}
	}

	.media-library-popup-download-link {
		display: flex;
		align-items: center;
		justify-content: center;
		min-width: var(--downloadLinkMinWidth);
		width: fit-content;
		padding: var(--downloadLinkPadding);
		border: 1px solid var(--primaryColor1);
		border-radius: var(--sp1-5x);
		transition: var(--trTime);
		margin-top: var(--downloadLinkMarginTop);

		@media (hover: hover) {
			&:hover {
				background-color: var(--primaryColor1);
				color: var(--primaryColor3);
			}
		}

		.download-btn-icon {
			font-size: var(--downloadLinkIconSizes);
			margin-left: var(--downloadLinkIconMarginLeft);
			transform: rotate(90deg);
		}
	}

	@media only screen and (max-width: ${(props) => props.theme.mediaQuery.DesktopSizeXLMin}) and (min-width: ${(props) => props.theme.mediaQuery.DesktopSizeL}) {
		:root {
			--mediaLibraryPopupImageSizes: var(--sp90x);
			--mediaLibraryPopupPadding: 0 var(--sp6x) var(--sp6x) var(--sp6x);
			--mediaLibraryPopupImageMarginRight: var(--sp6x);
			--mediaLibraryPopupContentWrapMarginTop: var(--sp10x);
			--mediaLibraryPopupNameMargin: var(--sp4x) 0;
			--mediaLibraryPopupInfoBlockMarginBottom: var(--sp3x);
			--mediaLibraryPopupInfoBlockMarginRight: var(--sp2x);
			--mediaLibraryPopupMaxWidth: var(--sp172x);

			--downloadLinkMinWidth: var(--sp29x);
			--downloadLinkPadding: var(--sp2x) var(--sp4x);
			--downloadLinkMarginTop: var(--sp2x);
			--downloadLinkIconSizes: var(--sp1-5x);
			--downloadLinkIconMarginLeft: var(--sp1-5x);

			--pdfPageControlsMarginTop: var(--sp3x);
			--pdfPageCounterMarginLeftRight: 0 var(--sp2x);
		}
	}

	@media only screen and (max-width: ${(props) => props.theme.mediaQuery.DesktopSizeLMin}) and (min-width: ${(props) => props.theme.mediaQuery.DesktopSizeM}) {
		:root {
			--mediaLibraryPopupImageSizes: var(--sp72x);
			--mediaLibraryPopupPadding: 0 var(--sp5x) var(--sp5x) var(--sp5x);
			--mediaLibraryPopupImageMarginRight: var(--sp5x);
			--mediaLibraryPopupContentWrapMarginTop: var(--sp8x);
			--mediaLibraryPopupNameMargin: var(--sp3x) 0;
			--mediaLibraryPopupInfoBlockMarginBottom: var(--sp2x);
			--mediaLibraryPopupInfoBlockMarginRight: var(--sp2x);
			--mediaLibraryPopupMaxWidth: var(--sp133x);

			--downloadLinkMinWidth: var(--sp24x);
			--downloadLinkPadding: var(--sp2x) var(--sp3x);
			--downloadLinkMarginTop: var(--sp2x);
			--downloadLinkIconSizes: var(--sp1x);
			--downloadLinkIconMarginLeft: var(--sp1-5x);

			--pdfPageControlsMarginTop: var(--sp3x);
			--pdfPageCounterMarginLeftRight: 0 var(--sp2x);
		}
	}

	@media only screen and (max-width: ${(props) => props.theme.mediaQuery.DesktopSizeMMin}) and (min-width: ${(props) => props.theme.mediaQuery.DesktopSizeS}) {
		:root {
			--mediaLibraryPopupImageSizes: var(--sp72x);
			--mediaLibraryPopupPadding: 0 var(--sp5x) var(--sp5x) var(--sp5x);
			--mediaLibraryPopupImageMarginRight: var(--sp5x);
			--mediaLibraryPopupContentWrapMarginTop: var(--sp7x);
			--mediaLibraryPopupNameMargin: var(--sp3x) 0;
			--mediaLibraryPopupInfoBlockMarginBottom: var(--sp2x);
			--mediaLibraryPopupInfoBlockMarginRight: var(--sp2x);
			--mediaLibraryPopupMaxWidth: var(--sp130x);

			--downloadLinkMinWidth: var(--sp24x);
			--downloadLinkPadding: var(--sp2x) var(--sp3x);
			--downloadLinkMarginTop: var(--sp2x);
			--downloadLinkIconSizes: var(--sp1x);
			--downloadLinkIconMarginLeft: var(--sp1-5x);

			--pdfPageControlsMarginTop: var(--sp3x);
			--pdfPageCounterMarginLeftRight: 0 var(--sp2x);
		}
	}

	@media only screen and (max-width: ${(props) => props.theme.mediaQuery.DesktopSizeSMin}) and (min-width: ${(props) => props.theme.mediaQuery.DesktopSizeXS}) {
		:root {
			--mediaLibraryPopupImageSizes: var(--sp62x);
			--mediaLibraryPopupPadding: 0 var(--sp3x) var(--sp3x) var(--sp3x);
			--mediaLibraryPopupImageMarginRight: var(--sp5x);
			--mediaLibraryPopupContentWrapMarginTop: var(--sp3x);
			--mediaLibraryPopupNameMargin: var(--sp3x) 0;
			--mediaLibraryPopupInfoBlockMarginBottom: var(--sp2x);
			--mediaLibraryPopupInfoBlockMarginRight: var(--sp2x);
			--mediaLibraryPopupMaxWidth: var(--sp120x);

			--downloadLinkMinWidth: var(--sp24x);
			--downloadLinkPadding: var(--sp2x) var(--sp3x);
			--downloadLinkMarginTop: var(--sp2x);
			--downloadLinkIconSizes: var(--sp1x);
			--downloadLinkIconMarginLeft: var(--sp1-5x);

			--pdfPageControlsMarginTop: var(--sp3x);
			--pdfPageCounterMarginLeftRight: 0 var(--sp2x);
		}

		.media-library-popup-image,
		.media-library-popup-pdf {
			margin-top: calc(var(--sp2x) * -1);
		}
	}

	@media only screen and (max-width: ${(props) => props.theme.mediaQuery.DesktopSizeXSMin}) and (min-width: ${(props) => props.theme.mediaQuery.TabletSize}) {
		:root {
			--mediaLibraryPopupImageSizes: var(--sp58x);
			--mediaLibraryPopupPadding: 0 var(--sp2x) var(--sp2x) var(--sp2x);
			--mediaLibraryPopupImageMarginRight: var(--sp5x);
			--mediaLibraryPopupContentWrapMarginTop: var(--sp1x);
			--mediaLibraryPopupNameMargin: var(--sp3x) 0;
			--mediaLibraryPopupInfoBlockMarginBottom: var(--sp2x);
			--mediaLibraryPopupInfoBlockMarginRight: var(--sp2x);
			--mediaLibraryPopupMaxWidth: var(--sp113x);

			--downloadLinkMinWidth: var(--sp24x);
			--downloadLinkPadding: var(--sp2x) var(--sp3x);
			--downloadLinkMarginTop: var(--sp2x);
			--downloadLinkIconSizes: var(--sp1x);
			--downloadLinkIconMarginLeft: var(--sp1-5x);

			--pdfPageControlsMarginTop: var(--sp2x);
			--pdfPageCounterMarginLeftRight: 0 var(--sp2x);
		}

		.media-library-popup-image,
		.media-library-popup-pdf {
			margin-top: calc(var(--sp3x) * -1);
		}
	}

	@media only screen and (max-width: ${(props) => props.theme.mediaQuery.TabletSizeMin}) and (min-width: ${(props) => props.theme.mediaQuery.TabletSizeS}) {
		:root {
			--mediaLibraryPopupImageSizes: 100%;
			--mediaLibraryPopupPadding: 0 var(--sp5x) var(--sp5x) var(--sp5x);
			--mediaLibraryPopupImageMarginRight: 0;
			--mediaLibraryPopupContentWrapMarginTop: var(--sp4x);
			--mediaLibraryPopupNameMargin: var(--sp3x) 0;
			--mediaLibraryPopupInfoBlockMarginBottom: var(--sp2x);
			--mediaLibraryPopupInfoBlockMarginRight: var(--sp2x);
			--mediaLibraryPopupMaxWidth: var(--sp75x);

			--downloadLinkMinWidth: var(--sp24x);
			--downloadLinkPadding: var(--sp2x) var(--sp3x);
			--downloadLinkMarginTop: var(--sp2x);
			--downloadLinkIconSizes: var(--sp1x);
			--downloadLinkIconMarginLeft: var(--sp1-5x);

			--pdfPageControlsMarginTop: var(--sp2x);
			--pdfPageCounterMarginLeftRight: 0 var(--sp2x);
		}

		.media-library-popup-styles {
			flex-direction: column;
		}
	}

	@media only screen and (max-width: ${(props) => props.theme.mediaQuery.TabletSizeSMin}) {
		:root {
			--mediaLibraryPopupImageSizes: 100%;
			--mediaLibraryPopupPadding: 0;
			--mediaLibraryPopupImageMarginRight: 0;
			--mediaLibraryPopupContentWrapMarginTop: var(--sp4x);
			--mediaLibraryPopupNameMargin: var(--sp3x) 0;
			--mediaLibraryPopupInfoBlockMarginBottom: var(--sp2x);
			--mediaLibraryPopupInfoBlockMarginRight: var(--sp2x);
			--mediaLibraryPopupMaxWidth: 100%;

			--downloadLinkMinWidth: var(--sp24x);
			--downloadLinkPadding: var(--sp2x) var(--sp3x);
			--downloadLinkMarginTop: var(--sp2x);
			--downloadLinkIconSizes: var(--sp1x);
			--downloadLinkIconMarginLeft: var(--sp1-5x);

			--pdfPageControlsMarginTop: var(--sp2x);
			--pdfPageCounterMarginLeftRight: 0 var(--sp1-5x);
		}

		.media-library-popup-download-link {
			margin-bottom: var(--sp18x);
		}

		.popup-content-container {
			.popup-content-wrap {
				max-height: 100% !important;
				height: 100% !important;
				border-radius: 0 !important;
			}
		}

		.media-library-popup-styles {
			flex-direction: column;

			.media-library-popup-image,
			.media-library-popup-pdf {
				margin-top: var(--sp7x);
			}
		}
	}
`}`;

export default MediaLibraryPopupStyle;
